/**
 * Canonical story path id: lowercase, trim, spaces → hyphens.
 * Keeps filtering consistent across Nest, Garden, and mixed API tag shapes.
 */
export function normalizeStoryPathId(tag) {
  return String(tag || 'general')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-');
}

/** Single story path for a book — set at import from admin description. */
export function getBookStoryPath(book) {
  if (book.story_path_primary) {
    return normalizeStoryPathId(book.story_path_primary);
  }
  const raw =
    Array.isArray(book.story_path_tags) && book.story_path_tags.length > 0
      ? book.story_path_tags[0]
      : book.category || 'general';
  return normalizeStoryPathId(raw);
}

/** True if book is tagged with this path (after normalizing tags and path id). */
export function bookBelongsToStoryPath(book, pathId) {
  return getBookStoryPath(book) === normalizeStoryPathId(pathId);
}
